/* unplugin-vue-components disabled */import { render } from "./yinsi.vue?vue&type=template&id=6d1f1f92&scoped=true"
import script from "./yinsi.vue?vue&type=script&lang=js"
export * from "./yinsi.vue?vue&type=script&lang=js"

import "./yinsi.vue?vue&type=style&index=0&id=6d1f1f92&lang=less&scoped=true"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1f1f92"]])

export default __exports__